module.exports = __webpack_public_path__ + "img/share_img.3ace6caa.png";